import React, {Component} from 'react'
import Btn from '../../Components/Btn/Btn'
import SVG from 'react-inlinesvg';
import Slider from 'react-slick';
import Stars from '../../Components/Stars/Stars'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {ActionCreators} from '../../Actions'
import {findOption} from '../../Lib/findOption'
import {listChefs} from '../../Services/Chefs/chefs'
import {positions} from '../../Lists/lists'
import { translate } from '../../Translations/translate';

function Arrow(props) {
    const {className, onClick} = props
    return (
        <div
            className={className}
            onClick={onClick}
            >
            <SVG src="/static/images/arrow.svg" />
            </div>
    );
}

class FeaturedChefs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: []
        }
        const { lang } = this.props.match.params
        listChefs({lang}).then((res) => {
            if (res.data.success) {
                this.setState({ items: res.data.data.list })
            }
        })
    }
    render() {
        let numberOfSlides = 1
        if (this.props.deviceScreen === 'tablet') {
            numberOfSlides = 3
        } else if (this.props.deviceScreen === 'desktop') {
            numberOfSlides = 4
        } else if (this.props.deviceScreen === 'large') {
            numberOfSlides = 4
        }
        let settings = {
            inifine: true,
            slidesToShow: numberOfSlides,
            slidesToScroll: 1,
            dots: false,
            nextArrow: <Arrow/>,
            prevArrow: <Arrow/>
        }
        let height = window.innerWidth / numberOfSlides
        return (
            <div className="component_FeaturedChefs" style={{height: height}}>
                <Slider
                    {...settings}
                    >
                    {this.renderItems()}
                </Slider>
            </div>
        )
    }
    renderItems() {
        let items = []
        this.state.items.forEach((item) => {
            items.push(this.renderItem(item))
        })
        return items
    }
    renderItem(item) {
        const { lang } = this.props.match.params
        let image = item.profile.images.profile ? item.profile.images.profile.sizes.square.url : 'http://via.placeholder.com/350x350'

        return (
            <div className="item" key={item.profile.id}>
                <div className="bg" style={{backgroundImage: 'url(' + image + ')'}}></div>
                <div className="content">
                    <h4>{item.profile.name}</h4>
                    {this.renderExperience(item)}
                    <Btn text={translate(lang, 'chef_profile').toUpperCase()} callback={() => {
                        this.props.history.push(`/${lang}/chef/view/` + item.profile.id + '/' + item.profile.slug)
                    }} />
                </div>
            </div>
        )
    }
    renderExperience(item) {
        const { lang } = this.props.match.params
        let experience = item.profile.experience.length > 0 ? item.profile.experience[0] : null
        if (!experience) {
            return null
        }
        return (
            <div>
                <h6>{findOption(experience.value.position, positions[lang])}</h6>
                <div className="restaurant">
                    <span className="location">{experience.value.company}</span>
                    <Stars type={experience.value.ratingType} number={parseInt(experience.value.rating)} />
                </div>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        deviceScreen: state.deviceScreen,

    }
}
export default withRouter(connect(mapStateToProps, ActionCreators)(FeaturedChefs))
